import { alpha, Stack, styled } from '@mui/material';

import { colors } from '@/shared/design-system/colors';

export const CardRoot = styled(Stack)(() => ({
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  borderRadius: '16px',
  background: colors.background.raised,
  width: '100%',
}));

export const HeaderRow = styled(Stack)({
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'flex-start',
});

export const CoverImage = styled('div', {
  shouldForwardProp: (prop: string) => prop !== '$src',
})<{ $src: string }>(({ $src }) => ({
  width: 104,
  height: 104,
  flex: '0 0 104px',
  borderRadius: 8,
  position: 'relative',
  backgroundImage: `linear-gradient(rgba(10,14,32,0.4), rgba(10,14,32,0.4)), url('${$src}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

export const HeaderTextCol = styled(Stack)({
  flexDirection: 'column',
  gap: '12px',
  flex: 1,
  minWidth: 0,
});

export const NameText = styled('h4')({
  margin: 0,
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '105%',
  color: colors.text.primary,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
});

export const EntityNameText = styled('span')({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '120%',
  color: colors.white[60],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const FeedersPill = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  padding: '2px 8px',
  borderRadius: '8px',
  background: alpha(colors.info.solid, 0.1),
  border: `1px solid ${alpha(colors.info.solid, 0.2)}`,
  color: colors.text.info,
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '14px',
  width: 'fit-content',
});

export const Divider = styled('div')({
  height: 1,
  width: '100%',
  background: colors.border.default,
});

export const StatusRow = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
});

export const StatusChip = styled(Stack, {
  shouldForwardProp: (prop: string) => prop !== '$color',
})<{ $color: string }>(({ $color }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  color: $color,
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
}));

export const MetricsCol = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
});

export const MetricRow = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '12px',
});

export const MetricLabel = styled('span')({
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  color: colors.white[60],
});

export const MetricValue = styled('span')({
  fontFamily: 'DM Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  color: colors.text.primary,
  textAlign: 'right',
});

export const ActionsRow = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '12px',
  width: '100%',
  '& > *': { flex: 1 },
}));
